<script setup>
import { ref, watch, inject } from 'vue'
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import { useToast } from 'vue-toast-notification'
import AppDialog from '#/general/AppDialog'
import AppMenu from '#/general/AppMenu'
const $toast = useToast({ position: 'bottom' })
const { isLoggedIn, authModalVisible, global, screen } = inject('Shared')
const props = defineProps(['page'])
const {
  mapStyle,
  leads,
  mapObj,
  showScoreBoard,
  showLeadListPopup,
  showFilters,
  showVideoPopup
} = useAnalyzer()
const showExplainer = ref(false)
const showSettings = ref(false)
function incrementZoom () {
  mapObj.value.flyTo({
    center: mapObj.value.getCenter(),
    zoom: mapObj.value.getZoom() + 1,
    bearing: 0,
    speed: 1,
    curve: 1,
    easing: (t) => t,
    essential: true
  })
}
function decrementZoom () {
  mapObj.value.flyTo({
    center: mapObj.value.getCenter(),
    zoom: mapObj.value.getZoom() + -1,
    bearing: 0,
    speed: 1,
    curve: 1,
    easing: (t) => t,
    essential: true
  })
}

function openGoogle () {
  window.open(`https://www.google.com/maps/search/?api=1&query=${mapObj.value.getCenter().lat},${mapObj.value.getCenter().lng}`, 'blank').focus()
}

const videoPlayerLoaded = ref(false)
let videoPlayer
watch(showVideoPopup, value => {
  if (value) {
    videoPlayer = document.createElement('script')
    videoPlayer.setAttribute('src', 'https://play.vidyard.com/embed/v4.js')
    document.head.appendChild(videoPlayer)
    setTimeout(() => {
      videoPlayerLoaded.value = true
    }, 500)
  } else {
    videoPlayer.parentNode.removeChild(videoPlayer)
    videoPlayerLoaded.value = false
  }
})

function openFilters () {
  if (!isLoggedIn.value) {
    $toast.open({ type: 'info', message: 'You must login to access this feature.' })
    authModalVisible.value = true
  }
}
function openScoreboard () {
  if (!isLoggedIn.value) {
    $toast.open({ type: 'info', message: 'You must login to access this feature.' })
    authModalVisible.value = true
  } else if (leads.value.length > 0) {
    showScoreBoard.value = true
  }
}

function openLeadList () {
  if (!isLoggedIn.value) {
    $toast.open({ type: 'info', message: 'You must login to access this feature.' })
    authModalVisible.value = true
  } else if (leads.value.length > 0) {
    showLeadListPopup.value = true
  }
}

watch(showSettings, val => {
  showExplainer.value = false
  if (val) {
    setTimeout(() => {
      showSettings.value = true
    }, 350)
  }
})
watch(showExplainer, val => {
  showSettings.value = false
  if (val) {
    setTimeout(() => {
      showExplainer.value = true
    }, 350)
  }
})
</script>

<template lang="pug">
.mapToolboxContainer(:class="page === 'WidgetAnalyzer' ? 'mapPageDesign' : ''")
  .relative-position
    app-menu(v-model:visible="showSettings" persistent position="top" content-width="350px" :offset="screen.lt.sm ? [page === 'B2BAnalyzer' ? 0 : -100, -5] : undefined")
      template(#parent)
        .toolboxBtn.settingBtn.styleBtn(
          @click="showSettings =! showSettings"
          :class="`${showSettings ? 'selectedBtn' : ''}; ${page !== 'B2BAnalyzer' ? 'roundedLeftBorder' : ''}`"
        )
          svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24')
            path(fill='none' d='M0 0h24v24H0z')
            path(d='M2.132 13.63a9.942 9.942 0 0 1 0-3.26c1.102.026 2.092-.502 2.477-1.431.385-.93.058-2.004-.74-2.763a9.942 9.942 0 0 1 2.306-2.307c.76.798 1.834 1.125 2.764.74.93-.385 1.457-1.376 1.43-2.477a9.942 9.942 0 0 1 3.262 0c-.027 1.102.501 2.092 1.43 2.477.93.385 2.004.058 2.763-.74a9.942 9.942 0 0 1 2.307 2.306c-.798.76-1.125 1.834-.74 2.764.385.93 1.376 1.457 2.477 1.43a9.942 9.942 0 0 1 0 3.262c-1.102-.027-2.092.501-2.477 1.43-.385.93-.058 2.004.74 2.763a9.942 9.942 0 0 1-2.306 2.307c-.76-.798-1.834-1.125-2.764-.74-.93.385-1.457 1.376-1.43 2.477a9.942 9.942 0 0 1-3.262 0c.027-1.102-.501-2.092-1.43-2.477-.93-.385-2.004-.058-2.763.74a9.942 9.942 0 0 1-2.307-2.306c.798-.76 1.125-1.834.74-2.764-.385-.93-1.376-1.457-2.477-1.43zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' fill='black')
      template(#content)
        div.transparent
          .row
            .googleBtn(@click="openGoogle") In Google-Maps öffnen
            .lightBtn(:class="mapStyle === 'LIGHT' ? 'selectedBtn' : ''" :style="mapStyle === 'LIGHT' ? `background: ${global.graphicElementColor} !important`: ''" @click="mapStyle = 'LIGHT'") Karte
            .sateliteBtn(:class="mapStyle === 'SATELLITE' ? 'selectedBtn' : ''" :style="mapStyle === 'SATELLITE' ? `background: ${global.graphicElementColor} !important`: ''" @click="mapStyle = 'SATELLITE'") Satellit
  app-menu(v-model:visible="showExplainer" persistent position="top" content-width="300px" :offset="screen.lt.sm ? [50, -5] : undefined" v-if="page === 'B2BAnalyzer'")
    template(#parent)
      .toolboxBtn.styleBtn
        .infoBtn(@click="showExplainer =! showExplainer" :class="showExplainer ? 'selectedBtn' : ''")
          svg(width="22" height="21" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg")
            path(d="M8.36726 16.738C8.36726 15.5593 8.62792 14.5847 9.14926 13.814C9.69326 13.0433 10.4753 12.1933 11.4953 11.264C12.2433 10.584 12.7873 10.0173 13.1273 9.564C13.4899 9.088 13.6713 8.55533 13.6713 7.966C13.6713 7.12733 13.3313 6.47 12.6513 5.994C11.9939 5.49533 11.1099 5.246 9.99926 5.246C8.93392 5.246 7.98192 5.47267 7.14326 5.926C6.32726 6.35666 5.63592 6.96867 5.06926 7.762L0.955258 5.348C1.90726 3.89733 3.18792 2.77533 4.79726 1.982C6.42926 1.18867 8.35592 0.792 10.5773 0.792C13.1839 0.792 15.2693 1.34733 16.8333 2.458C18.4199 3.56867 19.2133 5.11 19.2133 7.082C19.2133 8.01133 19.0546 8.82733 18.7373 9.53C18.4426 10.2327 18.0686 10.8333 17.6153 11.332C17.1846 11.808 16.6179 12.3633 15.9153 12.998C15.0766 13.746 14.4646 14.3807 14.0793 14.902C13.6939 15.4007 13.5013 16.0127 13.5013 16.738H8.36726ZM10.9513 25.272C10.0219 25.272 9.23992 24.9773 8.60526 24.388C7.99326 23.776 7.68726 23.0393 7.68726 22.178C7.68726 21.3167 7.99326 20.6027 8.60526 20.036C9.21726 19.4467 9.99926 19.152 10.9513 19.152C11.9033 19.152 12.6853 19.4467 13.2973 20.036C13.9093 20.6027 14.2153 21.3167 14.2153 22.178C14.2153 23.0393 13.8979 23.776 13.2633 24.388C12.6513 24.9773 11.8806 25.272 10.9513 25.272Z" fill="#130F26")
    template(#content)
      .row
        .googleBtn(@click="showVideoPopup = !showVideoPopup") Erklärvideo
        .lightBtn Glossar
  .toolboxBtn.styleBtn.zoomBtn(@click="incrementZoom")
    svg(width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg')
      path
      path(d='M17.5926 10.596H11.3286V16.716H6.68461V10.596H0.456609V6.204H6.68461V0.0839989H11.3286V6.204H17.5926V10.596Z' fill='#130F26')
  .toolboxBtn.styleBtn.zoomBtn(@click="decrementZoom" :class="['WidgetAnalyzer', 'B2CAnalyzer'].includes(page) ? 'roundedRightBorder' : ''")
    svg(width='12' height='6' viewBox='0 0 12 6' fill='none' xmlns='http://www.w3.org/2000/svg')
      path
      path(d='M0.928641 0.616H11.1166V5.116H0.928641V0.616Z' fill='#2F3849')
  template(v-if="page === 'B2BAnalyzer'")
    .toolboxBtn.smallActionBtn(@click='openFilters')
      .label(:style="showFilters ? 'color: white;' : ''") Filter
      slot(name="filters")
    .toolboxBtn.smallActionBtn(@click="openLeadList" :style="showLeadListPopup ? 'background: #007BFF;' : ''")
      .label(:style="showLeadListPopup ? 'color: white;' : ''") Liste
    .toolboxBtn.bigActionBtn(@click="openScoreboard" :style="showScoreBoard ? 'background: #007BFF;' : ''")
      .label(:style="showScoreBoard ? 'color: white;' : ''") Scoreboard
  app-dialog(v-model:show-modal="showVideoPopup" maximized)
    template(#modal-content)
      .video(v-show="videoPlayerLoaded")
        img.vidyard-player-embed(style='width: 100%; max-width: 800px !important; margin: auto; display: block;' src='https://play.vidyard.com/j4agk71htoaXkWSAxiRTBx.jpg' data-uuid='j4agk71htoaXkWSAxiRTBx' data-v='4' data-type='inline')
</template>

<style lang="sass">
.video
  min-width: 800px
  @media screen and (max-width: 1023px)
    min-width: initial
    width: 100%
.mapPageDesign
  @media screen and (max-width: 599px)
    justify-content: center
    bottom: 5px !important
.mapToolboxContainer
  z-index: 3
  position: absolute
  display: flex
  flex-direction: row
  @media screen and (min-width: 1024px)
    bottom: 25px
    left: 100px
  @media screen and (min-width: 600px) and (max-width: 1023px)
    left: 5%
    bottom: 25px
  @media screen and (max-width: 599px)
    bottom: 0px
    justify-content: center
    left: 0
    width: 100%
  .roundedLeftBorder
    border-radius:  10px 0px 0px 10px
  .roundedRightBorder
    border-radius:  0px 10px 10px 0px
  .settingBtn, .zoomBtn
    &:hover
      background: v-bind('global.graphicElementColor')
      svg
        path:nth-child(2)
          fill: white
  .settingBtn
    @media screen and (min-width: 600px)
      width: 38px
      height: 38px
      border-radius: 10px 0 0 10px
  .styleBtn
    width: 38px
    height: 38px
    transition: all 0.3s ease
    @media screen and (max-width: 599px)
      height: 44px
  .bigActionBtn
    margin-right: 0px !important
    @media screen and (min-width: 600px)
      padding: 13px 28px
      border-radius: 0px 10px 10px 0px
      width: 114px
    @media screen and (max-width: 599px)
      width: 27.6%
  .smallActionBtn
    @media screen and (min-width: 600px)
      width: 85px
    @media screen and (max-width: 599px)
      width: 18.6%
  .toolboxBtn
    transition: all 0.3s ease
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center
    background: #C4C4C4
    box-shadow: 0px 4px 16px rgba(98, 108, 133, 0.16)
    margin-right: 3px
    @media screen and (min-width: 600px)
      height: 38px
    @media screen and (max-width: 599px)
      height: 44px
    &:hover
      background: v-bind('global.graphicElementColor')
      .label
        color: white
    .label
      font-weight: 600
      line-height: 130%
      color: #22223C
      @media screen and (min-width: 600px)
        font-weight: 600
        font-size: 16px
      @media screen and (max-width: 599px)
        font-weight: 500
        font-size: 12px
  .infoBtn
    transition: all .2s
    cursor: pointer
    background: #C4C4C4
    width: 38px
    height: 38px
    display: flex
    justify-content: center
    align-items: center
  .infoBtn:hover
    background: v-bind('global.graphicElementColor')
    path, svg
      transition: fill .2s
      fill: white
  .infoBtn--container
    position: relative
    .infoBtn
      margin-top: 3px
.sateliteBtn
  transition: background-color 0.3s ease
  cursor: pointer
  background: #C4C4C4
  min-width: 76px
  padding: 0 10px
  height: 38px
  display: flex
  justify-content: center
  align-items: center
  border-radius:  0px 10px 10px 0px
  font-weight: 700
  font-size: 12px
  line-height: 30px
  text-align: center
  color: #2F3849
.lightBtn
  transition: background-color 0.3s ease
  cursor: pointer
  background: #C4C4C4
  width: 75px
  height: 38px
  display: flex
  justify-content: center
  align-items: center
  margin: 0px 3px
  font-weight: 700
  font-size: 12px
  line-height: 30px
  text-align: center
  color: #2F3849
.googleBtn
  cursor: pointer
  background: #C4C4C4
  padding: 0 10px
  height: 38px
  display: flex
  justify-content: center
  align-items: center
  border-radius:  10px 0px 0px 10px
  font-weight: 700
  font-size: 12px
  line-height: 30px
  text-align: center
  color: #2F3849
.selectedBtn
  color: white !important
  path, svg
    fill: white
.explainer-btn
  transition: fadeIn .3s
  background: v-bind('global.graphicElementColor')
  color: white
  font-weight: 700
  font-size: 12px
  border-radius: 10px
  padding: 0 14px
  height: 38px
</style>
